// types
import { ResetPasswordData } from './types';

export const convertResetPasswordValuesToDataModel = (email: any, token: any, values: ResetPasswordData): any => ({
  email: email || undefined,
  password: values.password || undefined,
  token: token || undefined,
});
